import React, { Component } from 'react'
import { Form, Input, Select, Button, message } from 'antd'
import BankInput from '../BankInput'
import { getPaymentInfoList, addPaymentInfoItem, updatePaymentInfoItem } from '@service/report'
import { JD_CERT_TYPE_OPTIONS, JD_PAYEE_TYPE_OPTIONS } from '../../../constants/report'
import './style.scss'
import SearchInput from '../../containers/ReportDetail/YuanTongReportDetailFoot/SearchInput';

const { Option } = Select

class PaymentInfoList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedKey: null,
            list: [],
            loading: false,
            initLoading: true
        }
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = async () => {
        const { flowId } = this.props
        if (!flowId) {
            this.setState({ initLoading: false })
            return
        }
        
        try {
            const result = await getPaymentInfoList({ flowId })
            if (result.errCode === 0) {
                const list = (result.result || []).map(item => ({ ...item, isNew: false }))
                this.setState({
                    list,
                    selectedKey: list.length > 0 ? 0 : null,
                    initLoading: false
                })
            } else {
                message.error(result.msg || '获取数据失败')
                this.setState({ initLoading: false })
            }
        } catch (err) {
            message.error('获取数据失败')
            this.setState({ initLoading: false })
        }
    }

    hasNewItem = () => {
        const { list } = this.state
        return list.some(item => item.isNew)
    }

    handleAdd = () => {
        if (this.props.disabled) {
            message.warning('权限不足')
            return
        }
        if (this.hasNewItem()) {
            message.warning('请先保存当前新增的领款人信息')
            return
        }
        const { list } = this.state
        const newList = [...list, {
            name: '',
            payeeType: undefined,
            certType: undefined,
            certCode: '',
            cellPhone: '',
            bankNo: undefined,
            bankBranchNo: undefined,
            bankCardNo: '',
            isNew: true
        }]
        this.setState({
            list: newList,
            selectedKey: newList.length - 1
        })
    }

    handleSelect = (index) => {
        this.setState({ selectedKey: index })
    }

    handleFieldChange = (field, value) => {
        this.handleFieldsChange({ [field]: value })
    }

    handleFieldsChange = (changes) => {
        const { list, selectedKey } = this.state
        if (selectedKey === null) return
        const newList = [...list]
        newList[selectedKey] = {
            ...newList[selectedKey],
            ...changes
        }
        this.setState({ list: newList })
    }

    handleSave = async () => {
        const { list, selectedKey } = this.state
        const { flowId } = this.props
        if (!flowId) {
            message.error('缺少工单ID')
            return
        }

        const currentItem = list[selectedKey]
        if (!currentItem.name) {
            message.error('请输入姓名')
            return
        }

        if (!currentItem.bankCardNo) {
            message.error('请输入银行卡号')
            return
        }

        if (!currentItem.payeeType) {
            message.error('请选择领款人类型')
            return
        }

        if (!currentItem.certType) {
            message.error('请选择证件类型')
            return
        }

        if (!currentItem.cellPhone) {
            message.error('请输入联系电话')
            return
        }

        if (!currentItem.bankNo) {
            message.error('请选择开户银行')
            return
        }

        if (!currentItem.bankCardNo) {
            message.error('请选择开户支行')
            return
        }

        const saveItem = {
            name: currentItem.name,
            payeeType: currentItem.payeeType,
            certType: currentItem.certType,
            certCode: currentItem.certCode,
            cellPhone: currentItem.cellPhone,
            bankNo: currentItem.bankNo,
            bankBranchNo: currentItem.bankBranchNo,
            bankCardNo: currentItem.bankCardNo
        }

        this.setState({ loading: true })
        try {
            let result
            if (currentItem.isNew) {
                result = await addPaymentInfoItem({
                    flowId,
                    item: saveItem
                })
            } else {
                result = await updatePaymentInfoItem({
                    flowId,
                    index: selectedKey,
                    item: saveItem
                })
            }
            
            if (result.errCode === 0) {
                message.success('保存成功')
                const newList = [...list]
                newList[selectedKey] = {
                    ...newList[selectedKey],
                    ...saveItem,
                    isNew: false
                }
                this.setState({ list: newList })
            } else {
                message.error(result.msg || '保存失败')
            }
        } catch (err) {
            message.error('保存失败')
        } finally {
            this.setState({ loading: false })
        }
    }

    getMenuName = (item) => {
        if (item.isNew) {
            return '待保存'
        }
        return item.name || '未命名'
    }

    renderForm = () => {
        const { selectedKey, list } = this.state
        const { actions, flowId } = this.props
        if (selectedKey === null || !list[selectedKey]) {
            return <div className="empty-tip">请选择或新增领款人</div>
        }
        const item = list[selectedKey]
        return (
            <div className="payment-form">
                <div className="form-items-row">
                    <div className="form-item">
                        <span className="label"><span style={{ color: 'red' }}>*</span> 姓名</span>
                        <Input
                            placeholder="请输入"
                            value={item.name}
                            onChange={e => this.handleFieldChange('name', e.target.value)}
                        />
                    </div>
                    <div className="form-item">
                        <span className="label"><span style={{ color: 'red' }}>*</span> 证件类型</span>
                        <Select
                            placeholder="请选择"
                            value={item.certType}
                            onChange={value => this.handleFieldChange('certType', value)}
                            style={{ width: '100%' }}
                        >
                            {JD_CERT_TYPE_OPTIONS.map(item => (
                                <Option key={item.value} value={item.value}>{item.label}</Option>
                            ))}
                        </Select>
                    </div>
                    <div className="form-item">
                        <span className="label"><span style={{ color: 'red' }}>*</span> 证件号</span>
                        <Input
                            placeholder="请输入"
                            value={item.certCode}
                            onChange={e => this.handleFieldChange('certCode', e.target.value)}
                        />
                    </div>
                    <div className="form-item">
                        <span className="label"><span style={{ color: 'red' }}>*</span> 领款人类型</span>
                        <Select
                            placeholder="请选择"
                            value={item.payeeType}
                            onChange={value => this.handleFieldChange('payeeType', value)}
                            style={{ width: '100%' }}
                        >
                            {JD_PAYEE_TYPE_OPTIONS.map(item => (
                                <Option key={item.value} value={item.value}>{item.label}</Option>
                            ))}
                        </Select>
                    </div>
                    <div className="form-item">
                        <span className="label"><span style={{ color: 'red' }}>*</span> 联系电话</span>
                        <Input
                            placeholder="请输入"
                            value={item.cellPhone}
                            onChange={e => this.handleFieldChange('cellPhone', e.target.value)}
                        />
                    </div>
                    <div className="form-item">
                        <span className="label"><span style={{ color: 'red' }}>*</span> 开户银行</span>
                        <BankInput
                            source="PaymentInfoList"
                            actions={actions}
                            flowId={flowId}
                            value={item.bankNo}
                            onChange={val => {
                                this.handleFieldsChange({ bankNo: val })
                            }}
                        />
                    </div>
                    {/*<div className="form-item">*/}
                    {/*    <span className="label"><span style={{ color: 'red' }}>*</span> 开户支行</span>*/}
                    {/*    <bankBranchNoInput*/}
                    {/*        source="PaymentInfoList"*/}
                    {/*        actions={actions}*/}
                    {/*        flowId={flowId}*/}
                    {/*        bankCode={item.bankNo}*/}
                    {/*        value={item.bankBranchNo}*/}
                    {/*        onChange={val => {*/}
                    {/*            this.handleFieldChange('bankBranchNo', val)*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <div className="form-item">
                        <span className="label"><span style={{ color: 'red' }}>*</span> 开户支行</span>
                        <SearchInput
                            value={item.bankBranchNo}
                            actions={actions}
                            onChange={val => {
                                this.handleFieldChange('bankBranchNo', val)
                            }}
                        />
                    </div>
                    <div className="form-item">
                        <span className="label"><span style={{ color: 'red' }}>*</span> 银行卡号</span>
                        <Input
                            placeholder="请输入"
                            value={item.bankCardNo}
                            onChange={e => this.handleFieldChange('bankCardNo', e.target.value)}
                        />
                    </div>
                </div>
                <div className={`form-actions ${ this.props.disabled ? 'no-border' : ''}`}>
                    {
                        !this.props.disabled && (
                            <Button type="primary" onClick={this.handleSave} loading={this.state.loading}>
                                保存
                            </Button>
                        )
                    }
                </div>
            </div>
        )
    }

    render() {
        const { list, selectedKey, initLoading } = this.state
        const hasNew = this.hasNewItem()

        if (initLoading) {
            return <div className="payment-info-list-container">加载中...</div>
        }

        return (
            <div className="payment-info-list-container">
                <div className="left-panel">
                    <div className="add-btn">
                        <Button 
                            type="primary" 
                            onClick={this.handleAdd}
                        >
                            + 新增领款人
                        </Button>
                    </div>
                    <div className="menu-list">
                        {list.map((item, index) => (
                            <div
                                key={index}
                                className={`menu-item ${selectedKey === index ? 'active' : ''} ${item.isNew ? 'new-item' : ''}`}
                                onClick={() => this.handleSelect(index)}
                            >
                                <span className="name">{this.getMenuName(item)}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="right-panel">
                    {this.renderForm()}
                </div>
            </div>
        )
    }
}

export default PaymentInfoList
